import React from 'react';
import { Box, CustomTheme, Stack, Typography, useTheme } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { IDropzone } from './interfaces';
import { useTranslation } from 'react-i18next';

export const Dropzone: React.FC<IDropzone> = ({
  children,
  onSelect,
}): JSX.Element => {
  const theme = useTheme<CustomTheme>();
  const { t } = useTranslation();
  const { getRootProps, getInputProps } = useDropzone({
    accept: { 'image/*': ['.png', '.jpeg', '.jpg'] },
    maxFiles: 1,
    multiple: false,
    onDrop: (acceptedFiles) => {
      // TODO: do stuff when validation failed.
      if (acceptedFiles) {
        onSelect(acceptedFiles);
      }
    },
  });

  return (
    <Box
      {...getRootProps()}
      sx={{
        p: 3,
        border: `1px dashed ${theme.palette.grey[600]}`,
        textAlign: 'center',
        cursor: 'pointer',
        borderRadius: '4px',
        '&:hover': {
          borderColor: theme.palette.grey[800],
          '.icon, span': {
            color: theme.palette.grey[800],
          },
        },
      }}
    >
      <input {...getInputProps()} />
      <Stack alignItems="center">
        <CloudUploadIcon
          className="icon"
          sx={{
            width: '40px',
            height: '40px',
            color: theme.palette.grey[600],
          }}
        />
        <Typography
          variant="body2"
          component="span"
          color={theme.palette.grey[600]}
        >
          {t('dialogs.uploadImage.placeholders.dropzone')}
        </Typography>
        {children}
      </Stack>
    </Box>
  );
};
